import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import ReactGA from "react-ga";
import log from "loglevel";
import {
  decodeJwtAction,
  getAboutMicroservicesAction,
} from "store/actions/actionCreators";
import { getAboutMicroservicesReducerResponse } from "store/selectors";
import { AboutMicroservice } from "types";
import AboutPageView from "./AboutPageView";
import * as routes from "routes";

type Component = React.FC<{}>;

const AboutPage: Component = function () {
  const dispatch = useDispatch();
  const history = useHistory();

  const microservicesData: AboutMicroservice[] = useSelector((state) =>
    getAboutMicroservicesReducerResponse(state, "data")
  );

  useEffect(() => {
    log.info("DashboardMicroservices useEffect()...");
    dispatch(decodeJwtAction({}));
    dispatch(getAboutMicroservicesAction({}));
  }, [dispatch]);

  return (
    <div>
      {microservicesData ? (
        <AboutPageView microservices={microservicesData} />
      ) : null}
    </div>
  );
};

export default AboutPage;
